import { render, staticRenderFns } from "./ModalMensaje.vue?vue&type=template&id=2130e8cb&scoped=true"
import script from "./ModalMensaje.vue?vue&type=script&lang=js"
export * from "./ModalMensaje.vue?vue&type=script&lang=js"
import style0 from "./ModalMensaje.vue?vue&type=style&index=0&id=2130e8cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2130e8cb",
  null
  
)

export default component.exports